const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShirt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.414,
    height: 30,
    viewBox: "0 0 38.414 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 164954"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Subtra\\xE7\\xE3o 10",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.047 30H8.371V11.941l-2.926 1.895L0 5.461 8.371.012V0h8.477A2.5 2.5 0 0 0 19.2 3.332a2.5 2.5 0 0 0 2.508-2.5A2.577 2.577 0 0 0 21.566 0h8.48v.02l8.364 5.433-5.449 8.383-2.914-1.887V30z",
    style: {
      stroke: "none"
    },
    transform: "translate(.004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.047 27V11.95a3 3 0 0 1 4.63-2.519l.4.26 2.182-3.357L29.128 3h-4.862a5.517 5.517 0 0 1-5.063 3.332A5.505 5.505 0 0 1 14.151 3H9.28L4.147 6.34l2.18 3.35.414-.267a3 3 0 0 1 4.63 2.518V27h15.676m3 3H8.37V11.941l-2.926 1.895L-.004 5.46 8.371.01 8.375 0h8.477a2.498 2.498 0 0 0 2.352 3.332A2.503 2.503 0 0 0 21.71.836c0-.281-.05-.563-.145-.836h8.48v.02l8.364 5.433-5.45 8.383-2.913-1.887V30z",
    style: {
      fill: "currentColor",
      stroke: "none"
    },
    transform: "translate(.004)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/Shirt.307027a9f8eba627014dd51a57c7cad7.svg";
export { ForwardRef as ReactComponent };